import { useCallback } from "react";

import { ProcessSignalNumber } from "Api/adminAgent/types/ProcessSignal.enum";
import { ServiceProcess } from "Api/adminAgent/types/ServiceProcess.type";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { useAppDispatch } from "Store/hooks";

import { selectAdminAgentUrl } from "../serviceProcesses.selectors";
import { sendServiceProcessesSignalThunk } from "../thunks/sendServiceProcessesSignal.thunk";

export const useSendServiceProcessesSignal = () => {
  const adminAgentUrl = useSelectorWithUrlParams(selectAdminAgentUrl);

  const dispatch = useAppDispatch();

  const sendServiceProcessesSignal = useCallback(
    (process: ServiceProcess, signal: ProcessSignalNumber) =>
      dispatch(
        sendServiceProcessesSignalThunk({
          adminAgentUrl,
          process,
          signal
        })
      ),
    [dispatch, adminAgentUrl]
  );

  return sendServiceProcessesSignal;
};
